import { Folder, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'components/ui/button';

import type { IFolder } from 'features/chat/agent-chat-module/types/kb.service.type';

type AgentConfigFolderCardProps = {
  folder: IFolder;
  onRemove: (folderId: string) => void;
  disabled?: boolean;
};

export function AgentConfigFolderCard({
  folder,
  onRemove,
  disabled = false,
}: AgentConfigFolderCardProps) {
  const navigate = useNavigate();

  const handleOpenFolder = () => {
    if (disabled) {
      return;
    }

    navigate(`/knowledge-base/${folder._id}`);
  };

  return (
    <div
      className={`flex min-w-0 items-center justify-between gap-3 rounded-lg border border-border bg-background p-4 ${disabled ? 'opacity-50' : ''
        }`}
    >
      <button
        type="button"
        disabled={disabled}
        onClick={handleOpenFolder}
        className="flex min-w-0 flex-1 items-center gap-3 rounded-md text-left transition-colors hover:bg-muted/50 disabled:cursor-not-allowed"
      >
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded bg-primary/10">
          <Folder className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="truncate text-sm font-medium text-foreground">
            {folder.Name || 'Unnamed Folder'}
          </div>
          <div className="line-clamp-1 break-all text-sm text-muted-foreground">
            {folder.Description || 'No description'}
          </div>
        </div>
      </button>

      <Button
        type="button"
        variant="outline"
        size="icon"
        disabled={disabled}
        className="h-9 w-9 shrink-0 text-muted-foreground hover:text-destructive disabled:cursor-not-allowed disabled:opacity-50"
        onClick={(event) => {
          event.stopPropagation();
          onRemove(folder._id);
        }}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
